import BaseService from "./BaseService";
import {ROOT, WITHDRAWAL} from "./_base";

class WithdrawalService extends BaseService {

    async withdrawalConfirm(configs) {
        const response = await this.post(`${ROOT}/${WITHDRAWAL}/request-withdrawal-confirm`, configs);
        return response.data;
    }

    async index() {
        const response = await this.getByUri(`${ROOT}/${WITHDRAWAL}/index`);
        return response.data;
    }

    async getWithdrawalHistory(params) {
        const response = await this.getByUri(`${ROOT}/${WITHDRAWAL}/get-withdrawal-history?index=` + params);
        return response.data;
    }

    async submitWithdrawal(params) {
        const response = await this.post(`${ROOT}/${WITHDRAWAL}/submit-withdrawal`, params);
        return response.data;
    }

    async withdrawalCancel(params) {
        const response = await this.post(`${ROOT}/${WITHDRAWAL}/withdrawal-cancel`, params);
        return response.data;
    }
}

export default WithdrawalService;
